import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 用户信息分页列表
export function getUserPager(req) {
  return request({
    url: apiConfig.userInfo.api.pager.url,
    method: "post",
    data: {
      page: req.page,
      pageSize: req.pageSize,
      realName: req.realName,
      idNumber: req.idNumber,
      createBy: req.createBy,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate,
      agentIds: req.agentIds,
      tags: req.tags,
      bindStatus: req.bindStatus
    }
  });
}

// 用户信息分页列表搜索功能
export function searchUserPager(req) {
  return request({
    url: apiConfig.userInfo.api.searchPager.url,
    method: "post",
    data: {
      page: req.page,
      pageSize: req.pageSize,
      realName: req.realName,
      idNumber: req.idNumber,
      createBy: req.createBy,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate,
      agentIds: req.agentIds,
      remarks: req.remarks,
      bindStatus: req.bindStatus
    }
  });
}
// 查询用户信息
export function findUser(id) {
  return request({
    url: apiConfig.userInfo.api.find.url,
    method: "get",
    params: {
      userId: id
    }
  });
}
// 新增用户信息
export function addUser(req) {
  return request({
    url: apiConfig.userInfo.api.add.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      idPhoto: req.idPhoto,
      mphone: req.mphone
    }
  });
}
export function mergeAccount(userId, mphone) {
  return request({
    url: apiConfig.userInfo.api.mergeAccount.url,
    method: "post",
    params: {
      userId: userId,
      mphone: mphone
    }
  });
}
// 更新用户信息
export function updateUser(userId, req) {
  return request({
    url: apiConfig.userInfo.api.update.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      realName: req.realName,
      mphone: req.mphone,
      sex: req.sex,
      email: req.email,
      birthDay: req.birthDay,
      addr: req.addr,
      nation: req.nation,
      edu: req.edu,
      capatity: req.capatity,
      subject: req.subject,
      idNumber: req.idNumber,
      idPhoto: req.idPhoto,
      school: req.school
    }
  });
}
// 下载导入证件照错误信息
export function exportIdPhotoError() {
  return request({
    url: apiConfig.userInfo.api.importIdPhoto.url.exportError,
    method: "get",
    responseType: "blob"
  });
}
// 下载导入用户错误信息
export function exportUserInfoError() {
  return request({
    url: apiConfig.userInfo.api.doImportUserInfo.url.exportError,
    method: "get",
    responseType: "blob"
  });
}
// 导出个人信息
export function exportUserList(searchForm) {
  return request({
    url: apiConfig.userInfo.api.exportUserList.url,
    method: "post",
    data: searchForm,
    responseType: "blob"
  });
}

// 查询用户简历信息
export function findUserResumeInfo(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResume.url,
    method: "get",
    params: {
      userId: id
    }
  });
}

// 保存用户简历信息
export function updateUserResumeInfo(req) {
  return request({
    url: apiConfig.userResumeInfo.api.update.url,
    method: "post",
    params: {
      userId: req.userId
    },
    data: {
      id: req.id,
      sex: req.sex,
      birthday: req.birthday,
      nationality: req.nationality,
      politicalStatus: req.politicalStatus,
      email: req.email,
      address: req.address,
      education: req.education,
      major: req.major,
      workYear: req.workYear,
      graduateSchool: req.graduateSchool
    }
  });
}

// 获取荣誉证书列表
export function getResumeCertificateList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeCertificateList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}

// 获取荣誉证书
export function findResumeCertificate(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeCertificate.url,
    method: "get",
    params: {
      id: id
    }
  });
}

// 新增荣誉证书
export function addResumeCertificate(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeCertificate.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      certificateName: req.certificateName,
      issuedBy: req.issuedBy,
      winningTime: req.winningTime,
      uploadCertificate: req.uploadCertificate
    }
  });
}

// 更新荣誉证书
export function updateResumeCertificate(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeCertificate.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      certificateName: req.certificateName,
      issuedBy: req.issuedBy,
      winningTime: req.winningTime,
      uploadCertificate: req.uploadCertificate
    }
  });
}

// 删除荣誉证书
export function deleteResumeCertificate(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeCertificate.url,
    method: "post",
    params: {
      id: id
    }
  });
}

// 获取教育经历列表
export function getResumeEducationList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeEducationList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}

// 获取教育经历证书
export function findResumeEducation(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeEducation.url,
    method: "get",
    params: {
      id: id
    }
  });
}

// 新增教育经历证书
export function addResumeEducation(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeEducation.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      startTime: req.startTime,
      degree: req.degree,
      endTime: req.endTime,
      school: req.school,
      major: req.major,
      education: req.education,
      serve: req.serve,
      uploadEducationAnnex: req.uploadEducationAnnex
    }
  });
}

// 更新教育经历证书
export function updateResumeEducation(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeEducation.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      startTime: req.startTime,
      degree: req.degree,
      endTime: req.endTime,
      school: req.school,
      major: req.major,
      education: req.education,
      serve: req.serve,
      uploadEducationAnnex: req.uploadEducationAnnex
    }
  });
}

// 删除教育经历证书
export function deleteResumeEducation(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeEducation.url,
    method: "post",
    params: {
      id: id
    }
  });
}

// 获取实习经历列表
export function getResumeInternshipList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeInternshipList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}

// 获取实习经历
export function findResumeInternship(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeInternship.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增实习经历
export function addResumeInternship(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeInternship.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      companyName: req.companyName,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 更新实习经历
export function updateResumeInternship(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeInternship.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      companyName: req.companyName,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 删除实习经历
export function deleteResumeInternship(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeInternship.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 获取项目经历列表
export function getResumeProjectList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeProjectList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}
// 获取项目经历
export function findResumeProject(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeProject.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增项目经历
export function addResumeProject(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeProject.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      projectName: req.projectName,
      startTime: req.startTime,
      endTime: req.endTime,
      projectResult: req.projectResult,
      projectDuty: req.projectDuty
    }
  });
}
// 更新项目经历
export function updateResumeProject(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeProject.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      projectName: req.projectName,
      startTime: req.startTime,
      endTime: req.endTime,
      projectResult: req.projectResult,
      projectDuty: req.projectDuty
    }
  });
}
// 删除项目经历
export function deleteResumeProject(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeProject.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 获取培训经历列表
export function getResumeTrainingList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeTrainingList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}
// 获取培训经历
export function findResumeTraining(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeTraining.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增培训经历
export function addResumeTraining(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeTraining.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      trainingCompany: req.trainingCompany,
      trainingLevel: req.trainingLevel,
      startTime: req.startTime,
      endTime: req.endTime,
      trainingContent: req.trainingContent,
      achievements: req.achievements,
      uploadProof: req.uploadProof,
      trainingHours: req.trainingHours,
      courseName: req.courseName,
      certificateNo: req.certificateNo,
      certificateType: req.certificateType
    }
  });
}
// 更新培训经历
export function updateResumeTraining(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeTraining.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      trainingCompany: req.trainingCompany,
      trainingLevel: req.trainingLevel,
      startTime: req.startTime,
      endTime: req.endTime,
      trainingContent: req.trainingContent,
      achievements: req.achievements,
      uploadProof: req.uploadProof,
      trainingHours: req.trainingHours,
      courseName: req.courseName,
      certificateNo: req.certificateNo,
      certificateType: req.certificateType
    }
  });
}
// 删除培训经历
export function deleteResumeTraining(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeTraining.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 获取工作经历列表
export function getResumeWorkList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeWorkList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}
// 获取工作经历
export function findResumeWork(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeWork.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增工作经历
export function addResumeWork(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeWork.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      companyName: req.companyName,
      companyType: req.companyType,
      tradeType: req.tradeType,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 更新工作经历
export function updateResumeWork(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeWork.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      companyName: req.companyName,
      companyType: req.companyType,
      tradeType: req.tradeType,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 删除工作经历
export function deleteResumeWork(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeWork.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 绑定用户项目
export function bindUserProject(userIds, projectIds) {
  return request({
    url: apiConfig.userInfo.api.bindUserProject.url,
    method: "post",
    data: userIds,
    params: {
      projectIds: projectIds
    }
  });
}

// 确认上传用户信息
export function doUploadUser(flag) {
  return request({
    url: apiConfig.userInfo.api.doImportUserInfo.url.import,
    method: "post",
    params: {
      flag: flag
    }
  });
}

// 确认上传用户信息
export function doUploadUserSpecial(flag) {
  return request({
    url: apiConfig.userInfo.api.doImportUserInfo.url.importSpecial,
    method: "post",
    params: {
      flag: flag
    }
  });
}

// 获取本机构下所有子机构
export function getAgentChildAll() {
  return request({
    url: apiConfig.userInfo.api.getAgentChildAll.url,
    method: "get"
  });
}

// 查看用户绑定的考场
export function viewExam(req) {
  return request({
    url: apiConfig.userInfo.api.viewExam.url,
    method: "post",
    params: {
      userId: req
    }
  });
}

// 批量添加用户标签
export function batchAddTags(params, data) {
  return request({
    url: apiConfig.userInfo.api.batchAddTags.url,
    method: "post",
    params,
    data
  });
}

// 模糊搜索用户标签
export function getTagsLike(params) {
  return request({
    url: apiConfig.userInfo.api.getTagsLike.url,
    method: "get",
    params,
  });
}

// 获取活动统计数据
export function getActivityStatistics(params) {
  return request({
    url: apiConfig.userInfo.api.getActivityStatistics.url,
    method: "get",
    params,
  });
}
// 获取活动统计数据
export function getActivityStatisticsAll(params) {
  return request({
    url: apiConfig.userInfo.api.getActivityStatisticsAll.url,
    method: "get",
    params,
  });
}
